/**
 * Tijdelijke placeholder tot echte assets. Designerbrief staat in `brief` (voor o.a. image generators).
 * Aanbevolen exportformaat: WebP of PNG, 2× voor retina.
 */
export function ImagePlaceholder({
  ratio,
  caption,
  brief,
  className = '',
}: {
  /** Beeldverhouding */
  ratio: '16:9' | '4:3' | '1:1' | '21:9';
  caption: string;
  /** Korte briefing: inhoud, stijl, compositie — voor ontwerp / AI-beeld */
  brief: string;
  className?: string;
}) {
  const aspect: Record<typeof ratio, string> = {
    '16:9': 'aspect-video',
    '4:3': 'aspect-[4/3]',
    '1:1': 'aspect-square',
    '21:9': 'aspect-[21/9]',
  };

  return (
    <figure
      className={`ct-hover-surface overflow-hidden rounded-2xl border border-dashed border-ct-border bg-ct-elevated/40 ${className}`}
    >
      <div
        className={`${aspect[ratio]} flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-ct-accent/10 via-ct-surface to-ct-elevated p-6 text-center`}
      >
        <span className="rounded-full border border-ct-border bg-ct-surface/80 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-ct-muted">
          Placeholder
        </span>
        <figcaption className="max-w-sm text-sm font-semibold text-ct-text">{caption}</figcaption>
      </div>
      <div className="border-t border-ct-border/60 bg-ct-surface/30 px-4 py-3">
        <p className="text-[11px] leading-relaxed text-ct-muted sm:text-xs">
          <span className="font-semibold text-ct-text/90">Brief voor beeld: </span>
          {brief}
        </p>
      </div>
    </figure>
  );
}
